// extracted by mini-css-extract-plugin
export default {"loginIcons":"Login_loginIcons__n27Sk"};